import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { EnhancedPanelBone } from '../../organisms/EnhancedPanelBone/EnhancedPanelBone';

type PanelMode = 'simple' | 'enhanced';

interface SplitViewSkeletonProps {
    /** Nombre de panneaux */
    panels?: number;

    /**
     * Mode d'affichage par panel (prioritaire sur panelMode)
     * Index du tableau correspond à l'index du panel
     * @example ['simple', 'enhanced', 'simple'] pour 3 panels avec des modes différents
     */
    panelModes?: PanelMode[];

    /**
     * Mode d'affichage global (utilisé si panelModes non défini ou pour les panels non spécifiés)
     * @deprecated Utilisez panelModes pour plus de flexibilité
     */
    panelMode?: PanelMode;

    /** Durée minimale d'affichage */
    minDuration?: number;

    /** Styles personnalisés */
    sx?: SxProps<Theme>;
}

export const SplitViewSkeleton: React.FunctionComponent<SplitViewSkeletonProps> = function ({
    panels = 2,
    panelModes,
    panelMode = 'simple',
    minDuration = 800,
    sx = {},
}) {
    /**
     * Obtient le mode pour un panel donné
     * Priorité : panelModes[index] > panelMode (fallback)
     */
    const getPanelMode = (index: number): PanelMode => {
        if (panelModes && panelModes[index] !== undefined) {
            return panelModes[index];
        }
        return panelMode;
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100vh',
                ...sx,
            }}
        >
            {Array.from({ length: panels }).map((_, index) => {
                const currentMode = getPanelMode(index);

                return (
                    <EnhancedPanelBone
                        key={`split-panel-${panels}-${index + 1}`}
                        mode={currentMode}
                        minDuration={minDuration}
                        sx={{
                            flex: 1,
                            width: '100%',
                            height: '90%',
                        }}
                    />
                );
            })}
        </Box>
    );
};
